export const paths = [
  '/users',
  '/users/:action',
  '/users/:action/:userId',
  '/users/create/access-level',
];

export const profilePath = '/profile';
